import { COOKIE_KEY, API_BASE_PATH } from './constants';
import { bake_cookie, read_cookie, delete_cookie } from 'sfcookies';

function readFromCookie(){
	let cookies = {};
	try {
		cookies = JSON.parse(read_cookie(COOKIE_KEY));
	} catch (_) {
	}
	return cookies;
};

function storeCookie(cookieData) {
	try {
		bake_cookie(COOKIE_KEY, JSON.stringify(cookieData));
	} catch (_) {
	}
};

function deleteCookie() {
	try {
		delete_cookie(COOKIE_KEY);
	} catch (_) {
	}
};

function verifyUserByRole(roles) {
	const found = roles.find(role => {
		return (role === 'ADMIN' || role === 'ADMIN_RO');
	});

	if (found === undefined) {
		throw new Error('Unauthorized User');
	}
}

function login({ username, password }) {
	const request = new Request(`${API_BASE_PATH}/auth/authentications:login`, {
		method: 'POST',
		body: JSON.stringify({
			userIdentifier: username,
			password: password
		}),
		headers: new Headers({
			'Content-Type': 'application/json;charset=UTF-8'
		})
	});
	return fetch(request)
		.then(async response => {
			if (response.status < 200 || response.status >= 300) {
				throw new Error(response.statusText);
			}
			const json = await response.json();
			const { apiKey, roles } = json.data;

			verifyUserByRole(roles);

			storeCookie({
				email: username,
				apiKey,
				roles
			});
		});
}

function logout() {
	let authentication = readFromCookie();
	if (authentication && authentication.apiKey) {
		const request = new Request(`${API_BASE_PATH}/auth/authentications:logout`, {
			method: 'POST',
			headers: new Headers({
				'Api-Key': authentication.apiKey,
				'Content-Type': 'application/json;charset=UTF-8'
			})
		});
		return fetch(request).then(response => {
			if (response.status < 200 || response.status >= 300) {
				throw new Error(response.statusText);
			}
			delete_cookie(COOKIE_KEY);
		});
	} else {
		return Promise.resolve();
	}
}

function checkAuth() {
	let authentication = readFromCookie();
	if (authentication && authentication.apiKey) {
		return Promise.resolve();
	} else {
		return Promise.reject();
	}
}

function checkError({ message }) {
	//reject and start over in case the api responds with UNAUTHORIZED or if the cookie is damaged
	if (message.indexOf('JSON') >= 0 || message.indexOf('401') >= 0 || message.indexOf('403') >= 0) {
		deleteCookie();
	}
	return Promise.resolve();
}

function getPermissions() {
	let authentication = readFromCookie();
	if (authentication && authentication.apiKey) {
		return Promise.resolve(authentication.roles);
	} else {
		return Promise.resolve();
	}
}

function getIdentity() {
	const authentication = readFromCookie();
	if (authentication.email && authentication.roles && authentication.roles instanceof Array) {
		return Promise.resolve({id: authentication.email, fullName: authentication.email + ' (' + authentication.roles.join(', ') + ')'});
	} else {
		return Promise.resolve({id: '', fullName: ''});
	}
}

const coreWalletAuthProvider = {
	login,
	logout,
	checkAuth,
	checkError,
	getPermissions,
	getIdentity,
};

export default coreWalletAuthProvider;
